import React from 'react'

import Icon from '../../atoms/Icon/Icon'
import Text from '../../atoms/Text/Text'

type IconwithTextVariant =
  | 'primary'
  | 'primary-contained'
  | 'primary-profile'
  | 'primary-profile-contained'
  | 'secondary'
  | 'secondary-contained'

interface IconwithTextProps {
  id: string
  iconName: string
  className?: string
  textContent: [
    primaryString: { text: string; description?: string; style?: string },
    secondaryString?: { text: string; style?: string }
  ]
  variant?: IconwithTextVariant
  isIconVisible?: boolean
}

const IconwithText: React.FC<IconwithTextProps> = ({
  id,
  iconName,
  className,
  textContent,
  variant = 'primary',
  isIconVisible = true
}) => (
  <div id={id} className={`flex gap-1 ${className} icon-text--${variant} `}>
    {isIconVisible && (
      <div className="flex flex-col justify-center">
        <Icon name={iconName} className={`text-inherit icon-text__icon--${variant}`} />
      </div>
    )}
    <div className="flex flex-col justify-center">
      {textContent && textContent[0] && (
        <div className="flex gap-1">
          <Text id={`${id}-text`} className={textContent[0]?.style}>
            {textContent[0].text}
          </Text>
          {textContent[0]?.description && (
            <Text id={`${id}-description`} className={`hidden md:block ${textContent[0]?.style}`}>
              {textContent[0]?.description}
            </Text>
          )}
        </div>
      )}
      {textContent && textContent[1] && (
        <Text id={`${id}-text-secondary`} className={`${textContent[1].style} hidden icon-text--${variant}`}>
          {textContent[1].text}
        </Text>
      )}
    </div>
  </div>
)

export default IconwithText
